/** Defaults for idle logout modal and silent token refresh (override per environment). */
export const sessionConfigDefaults = {
  /** Minutes without input before showing the countdown modal. */
  idleMinutesBeforeWarning: 20,
  /** Minutes shown on the modal; logout if still no activity. */
  idleWarningMinutes: 5,
  /** Refresh access token silently when this many seconds remain (or if expired). */
  tokenRefreshBeforeExpirySeconds: 300
};

export type SessionConfig = typeof sessionConfigDefaults;
